import React from "react";
import { Link } from "react-router-dom";
import ThemeToggleButton from "./ThemeToggleButton";
import useIsMobile from "../hooks/useIsMobile";

const AdminNavbar = () => {
  const isMobile = useIsMobile();
  const logout = () => {
    localStorage.removeItem("token");
    // window.location.href = "login";
  };

  return (
    <div className="navbar fixed top-0 mx-auto shadow-xl bg-base-200 z-10 mb-12">
      <div className="navbar-center ">
        <Link to="/" onClick={logout} className="lg:ml-12 ">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="32px"
            width="32px"
            viewBox="0 -960 960 960"
            fill="#000000"
          >
            <path d="M202.57-140q-25.79 0-44.18-18.39T140-202.57v-554.86q0-25.79 18.39-44.18T202.57-820h277.4v50.26h-277.4q-4.62 0-8.47 3.84-3.84 3.85-3.84 8.47v554.86q0 4.62 3.84 8.47 3.85 3.84 8.47 3.84h277.4V-140h-277.4Zm459.38-181.54-35.85-35.95 97.39-97.38H363.85v-50.26h358.82l-97.39-97.38 35.59-36.21L820-479.46 661.95-321.54Z" />
          </svg>
        </Link>
        <Link to="/admin" className="lg:ml-12  ml-5">
          {isMobile ? (
            // Camera icon (Fotos)
            <svg
              width="24"
              height="24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              viewBox="0 0 24 24"
            >
              <circle cx="12" cy="13" r="4" />
              <path d="M5 7h2l2-3h6l2 3h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2z" />
            </svg>
          ) : (
            "Fotos"
          )}
        </Link>
        <Link to="/admin/atletas" className="lg:ml-12  ml-5">
          {isMobile ? (
            // Female user icon (Atletas)
            <svg
              width="24"
              height="24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              viewBox="0 0 24 24"
            >
              <circle cx="12" cy="8" r="4" />
              <path d="M16 20v-1a4 4 0 0 0-8 0v1" />
              <path d="M15 8c0-2-1-4-3-4s-3 2-3 4" />
            </svg>
          ) : (
            "Atletas"
          )}
        </Link>
        <Link to="/admin/compras/aprovar" className="lg:ml-12  ml-5">
          {isMobile ? (
            // Check icon (Aprovações)
            <svg
              width="24"
              height="24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              viewBox="0 0 24 24"
            >
              <polyline points="20 6 9 17 4 12" />
            </svg>
          ) : (
            "Aprovações"
          )}
        </Link>
        <Link to="/ar/home" className="lg:ml-12  ml-5">
          {isMobile ? (
            // Cart icon (Loja)
            <svg
              width="24"
              height="24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              viewBox="0 0 24 24"
            >
              <circle cx="9" cy="21" r="1" />
              <circle cx="20" cy="21" r="1" />
              <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" />
            </svg>
          ) : (
            "Loja"
          )}
        </Link>
        <Link to="/admin/athletes" className="lg:ml-12  ml-5">
          {isMobile ? (
            // Male user icon (Athletes)
            <svg
              width="24"
              height="24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              viewBox="0 0 24 24"
            >
              <circle cx="12" cy="8" r="4" />
              <path d="M16 20v-1a4 4 0 0 0-8 0v1" />
              <path d="M12 4c2 0 3 2 3 4" />
            </svg>
          ) : (
            "Athletes"
          )}
        </Link>
        <Link to="/admin/teams" className="lg:ml-12  ml-5">
          {isMobile ? (
            // Three users icon (Teams)
            <svg
              width="24"
              height="24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              viewBox="0 0 24 24"
            >
              <circle cx="6" cy="8" r="3" />
              <circle cx="18" cy="8" r="3" />
              <circle cx="12" cy="8" r="3" />
              <path d="M2 21v-2a4 4 0 0 1 4-4h2a4 4 0 0 1 4 4v2" />
              <path d="M14 21v-2a4 4 0 0 1 4-4h2a4 4 0 0 1 4 4v2" />
            </svg>
          ) : (
            "Teams"
          )}
        </Link>
        {/* Novo link para Gerenciar Atalhos */}
        <Link to="/admin/shortcuts" className="lg:ml-12 ml-5">
          {isMobile ? (
            // Gear/Settings icon
            <svg
              width="24"
              height="24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              viewBox="0 0 24 24"
            >
              <circle cx="12" cy="12" r="3" />
              <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 6.2 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0-.33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 6.2a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1.82.33 1.65 1.65 0 0 0 1 1.51V3a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.82.33z" />
            </svg>
          ) : (
            "Atalhos"
          )}
        </Link>
        <Link to="/admin/games" className="lg:ml-12 ml-5">
          {isMobile ? (
            // Volleyball icon (Games)
            <svg
              width="24"
              height="24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              viewBox="0 0 24 24"
            >
              <circle cx="12" cy="12" r="10" />
              <path d="M2 12a10 10 0 0 0 20 0" />
              <path d="M12 2a10 10 0 0 1 0 20" />
              <path d="M2 12h20" />
              <path d="M12 2v20" />
            </svg>
          ) : (
            "Games"
          )}
        </Link>
      </div>

      <div className="navbar-end">
        <ThemeToggleButton />
      </div>
    </div>
  );
};

export default AdminNavbar;
